<template>
  <div class="chat">
    <div class="timeTip_box">
          <div class="timeTip">你还有<span v-show="dd">{{ dd }}天</span>{{ hh }}小时{{ mm }}分钟{{
            ss
          }}秒的时间来回复对方
          </div>
        </div>
    <div class="content-box">
      <el-scrollbar style="height: 100%"
                    ref="myScrollbar">
        <div v-if="moreTextFlag"
             :class="[moreText == '暂无更多消息' ? 'greyMoreText' : 'moreText']"
             @click="more">
          {{ moreText }}
        </div>
        <div style="padding: 20px">
          <div v-for="(item, index) in list"
               :key="index">
            <!-- 接收到他人消息 -->
            <div class="chat-box"
                 v-if="item.senderType == 1">
              <div class="img-container">
                <!-- sendoutType发送类型(1.全球赢后台 2.whatsapp第三方) -->
                <div class="xiansuo contactProfilePicture">{{ checkChinese }}</div>
              </div>
              <div>
                <div style="height: 18px;  margin-left: 10px">
                  <span>
                    {{ item.nickname }}
                    <span style="font-size: 10px;margin-left: 20px"
                          v-if="checkIndex == index">
                      {{ item.sendTime }}
                    </span>
                  </span>
                </div>
                  <div style="height: 100%;">
                    <div class="chat-content"
                         v-if="item.contentList && item.contentList.length">
                     <!--图片-->
											<div
												class="imgcontent content reaction-box"
												v-if="
													item.contentList[0].msgType == 'image' ||
													item.contentList[0].msgType == 'sticker'
												"
												@mouseenter="mouseenter(index)"
												@mouseleave="mouseleave"
											>
												<div>
													<messageReference
														v-if="item.assocWhatsappInfoId"
														:assocContent="item.assocContentList ? item.assocContentList[0] : {}"
														:assocWhatsAppRecordUserVO="item.assocWhatsAppRecordUserVO"
                            :assocWhatsappInfoId="item.assocWhatsappInfoId"
													></messageReference>
													<div>
														<div v-if="imgFlag == index">
															<sky-img-preview
																:file="{
																	url: item.contentList[0].urls,
																	ossName: '8144864489269305344.png',
																}"
																file-name="AHHAH"
																:visible.sync="dialogVisible"
																title="查看图片"
																:img-url="item.contentList[0].urls"
																@on-cancel="showImg(index, -1)"
																:append="true"
															></sky-img-preview>
														</div>
														<img
															:src="item.contentList[0].urls"
															@click="showImg(index)"
															class="img-box"
														/>
														<div>{{ item.contentList[0].caption }}</div>
													</div>
												</div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info-recive">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
                     <!-- 视频 -->
											<div
												class="video_box reaction-box"
												:class="item.assocWhatsappInfoId ? 'content' : ''"
												v-else-if="item.contentList[0].msgType == 'video'"
												@mouseenter="mouseenter(index)"
												@mouseleave="mouseleave"
											>
												<div>
													<messageReference
														v-if="item.assocWhatsappInfoId"
														:assocContent="item.assocContentList ? item.assocContentList[0] : {}"
														:assocWhatsAppRecordUserVO="item.assocWhatsAppRecordUserVO"
                            :assocWhatsappInfoId="item.assocWhatsappInfoId"
													></messageReference>
													<video
														ref="videoPlayer"
														controls
														:src="item.contentList[0].urls"
														class="video_content"
													></video>
												</div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info-recive">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
											<!-- 文件 -->
											<div
												class="document_box reaction-box"
												:class="item.assocWhatsappInfoId ? 'content' : ''"
												v-else-if="item.contentList[0].msgType == 'document'"
												@mouseenter="mouseenter(index)"
												@mouseleave="mouseleave"
											>
												<messageReference
													v-if="item.assocWhatsappInfoId"
													:assocContent="item.assocContentList ? item.assocContentList[0] : {}"
													:assocWhatsAppRecordUserVO="item.assocWhatsAppRecordUserVO"
                          :assocWhatsappInfoId="item.assocWhatsappInfoId"
												></messageReference>
												<el-row
													class="file_style"
													@click.native="whatsappAttachmentDownload(item.contentList[0])"
												>
													<el-col :span="20" class="file_sub">
														<div>{{ item.contentList[0].fileName | fileNameFilter }}</div>
														<div class="fileSize">{{ item.contentList[0].fileSizeStr }}</div>
													</el-col>
													<el-col :span="4">
														<img
															:src="item.contentList[0].fileName | numfilters"
															class="fileName"
														/>
													</el-col>
												</el-row>
												<div class="error-text" v-if="item.contentList[0].sendType == 3">
													发送失败，点击重试
												</div>
												<div class="error-tip">
													<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
													<i
														class="el-icon-warning errorColor"
														v-if="item.contentList[0].sendType == 3"
														@click="repeatSendFileAction(item)"
													></i>
												</div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info-recive">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
                      <!-- 弹窗 -->
                      <!-- <div v-else-if="item.contentList[0].type == 5"></div> -->
                      <div
												v-else-if="item.contentList[0].msgType == 'audio'"
												:class="item.assocWhatsappInfoId ? 'content' : ''"
												class="video_box reaction-box"
											>
												<messageReference
													v-if="item.assocWhatsappInfoId"
													:assocContent="item.assocContentList ? item.assocContentList[0] : {}"
													:assocWhatsAppRecordUserVO="item.assocWhatsAppRecordUserVO"
                          :assocWhatsappInfoId="item.assocWhatsappInfoId"
												></messageReference>
												<audio-play :url="item.contentList[0].urls" :position="'left'"></audio-play>
												<div class="error-tip">
													<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
													<i
														class="el-icon-warning errorColor"
														v-if="item.contentList[0].sendType == 3"
														@click="repeatSendFileAction(item)"
													></i>
												</div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info-recive">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
											<!-- 文本 -->
											<div v-else-if="item.contentList[0].msgType == 'text'">
												<div @mouseleave="mouseleave" class="content reaction-box">
													<messageReference
														v-if="item.assocWhatsappInfoId"
														:assocContent="item.assocContentList ? item.assocContentList[0] : {}"
														:assocWhatsAppRecordUserVO="item.assocWhatsAppRecordUserVO"
                            :assocWhatsappInfoId="item.assocWhatsappInfoId"
													></messageReference>
													<div @mouseenter="mouseenter(index)">
														<div
															v-html="item.contentList[0].content.replace(/\n/g, '<br />')"
														></div>
													</div>
													<div
														v-if="item.contentList[0].reactionVO"
														class="reaction-info-recive"
														style="left: 50px"
													>
														{{ item.contentList[0].reactionVO.emoji }}
													</div>
												</div>
												<div>
													<!-- <div class="translate-text" v-if="item.contentList[0].translateStatus">
														{{ item.contentList[0].zhMsgContent }}
														<div class="tip">
															<i class="el-icon-success layout-style"></i
															>{{ item.contentList[0].fromName }}翻译完成
														</div>
													</div> -->
                          <translateFold
														:translateData="item.contentList[0]"
														v-if="item.contentList[0].translateStatus"
													/>
												</div>
											</div>

											<!-- 定位消息 -->
											<div
												v-else-if="item.contentList[0].msgType == 'location'"
												@mouseleave="mouseleave"
											>
												<div
													class="content reaction-box"
													v-if="item.contentList[0].locationVO"
													@mouseenter="mouseenter(index)"
												>
													<messageReference
														v-if="item.assocWhatsappInfoId"
														:assocContent="item.assocContentList ? item.assocContentList[0] : {}"
														:assocWhatsAppRecordUserVO="item.assocWhatsAppRecordUserVO"
                            :assocWhatsappInfoId="item.assocWhatsappInfoId"
													></messageReference>
													<!-- <baidu-map class="chat-map" :center="{lng: item.contentList[0].locationVO.longitude, lat: item.contentList[0].locationVO.latitude}" :zoom="17">
                            <bm-marker :position="{lng: item.contentList[0].locationVO.longitude, lat: item.contentList[0].locationVO.latitude}"></bm-marker>
                          </baidu-map> -->

													<!-- <div>{{ item.contentList[0].locationVO.address }}</div> -->
													<div
														style="font-size: 16px"
														v-if="
															!item.contentList[0].locationVO.address &&
															!item.contentList[0].locationVO.name
														"
													>
														定位消息
													</div>
													<div style="font-size: 16px" v-else>
														定位消息：{{ item.contentList[0].locationVO.name
														}}<span v-if="item.contentList[0].locationVO.name">，</span
														>{{ item.contentList[0].locationVO.address }}
													</div>
													<div v-if="item.contentList[0].reactionVO" class="reaction-info-recive">
														{{ item.contentList[0].reactionVO.emoji }}
													</div>
												</div>
												<div class="content" v-else @mouseenter="mouseenter(index)">
													未知定位信息
												</div>
											</div>
											<!-- 模板消息 -->
											<div
												v-else-if="item.contentList[0].msgType == 'button'"
												@mouseleave="mouseleave"
											>
												<div class="content reaction-box" @mouseenter="mouseenter(index)">
													<messageReference
														v-if="item.assocWhatsappInfoId"
														:assocContent="item.assocContentList ? item.assocContentList[0] : {}"
														:assocWhatsAppRecordUserVO="item.assocWhatsAppRecordUserVO"
                            :assocWhatsappInfoId="item.assocWhatsappInfoId"
													></messageReference>
													<div v-html="item.contentList[0].content"></div>
													<div v-if="item.contentList[0].reactionVO" class="reaction-info-recive">
														{{ item.contentList[0].reactionVO.emoji }}
													</div>
												</div>
											</div>
											<!-- 联系人消息 -->
											<div v-else-if="item.contentList[0].msgType == 'contacts'">
												<div
													class="content reaction-box"
													style="padding: 0"
													@mouseenter="mouseenter(index)"
												>
													<messageReference
														class="contact-reference"
														v-if="item.assocWhatsappInfoId"
														:assocContent="item.assocContentList ? item.assocContentList[0] : {}"
														:assocWhatsAppRecordUserVO="item.assocWhatsAppRecordUserVO"
                            :assocWhatsappInfoId="item.assocWhatsappInfoId"
													></messageReference>
													<div v-if="item.contentList[0].contactVOList">
														<div
															class="contact-info"
															:style="item.assocWhatsappInfoId ? 'padding-top: 0' : ''"
														>
															{{ item.contentList[0].contactVOList[0].name.formattedName
															}}<span v-if="item.contentList[0].contactVOList.length > 1"
																>等另外</span
															>{{
																item.contentList[0].contactVOList.length == 1
																	? ''
																	: item.contentList[0].contactVOList.length - 1 + '个联系人'
															}}
														</div>
														<div
															class="view-all"
															@click="viewContact(item.contentList[0].contactVOList)"
														>
															{{
																item.contentList[0].contactVOList.length == 1 ? '查看' : '查看全部'
															}}
														</div>
													</div>
													<div class="contact-info" v-else>暂无联系人信息</div>
													<div v-if="item.contentList[0].reactionVO" class="reaction-info-recive">
														{{ item.contentList[0].reactionVO.emoji }}
													</div>
												</div>
											</div>

											<div v-else @mouseleave="mouseleave">
												<div
													v-if="item.contentList[0].content"
													class="content reaction-box"
													v-html="item.contentList[0].content"
													@mouseenter="mouseenter(index)"
												></div>
												<div class="content" v-else @mouseenter="mouseenter(index)">
													暂不支持此类消息
												</div>
												<div>
													<div v-if="item.contentList[0].reactionVO" class="reaction-info-recive">
														{{ item.contentList[0].reactionVO.emoji }}
													</div>
												</div>
											</div>
                    </div>
                  </div>
              </div>
            </div>
            <!-- 自己发送的消息 -->
            <div class="chat-box-self"
                 v-else>
              <div class="chat-content-self">
                <p style="text-align: right; height: 18px">
                  <span style="font-size: 10px; margin-right: 15px"
                        v-if="checkIndex == index">
                    {{ item.sendTime }}
                  </span>
                  {{ item.nickname }}
                </p>
                  <div style="height: 100%;">
                    <div v-if="item.contentList && item.contentList.length">
                      <!--图片-->
											<div
												class="imgcontent-self reaction-box"
												v-if="
													item.contentList[0].msgType == 'image' ||
													item.contentList[0].msgType == 'sticker'
												"
												@mouseenter="mouseenter(index)"
												@mouseleave="mouseleave"
											>
												<div class="error-tip">
													<div
														v-if="newOrold && userType != 1 && item.contentList[0].sendType == 2"
													>
														<div v-if="item.readFlag == 1">
															<span class="read-font" v-if="textIndex == index">已读</span
															><i
																class="el-icon-circle-check"
																style="color: #999999"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
														<div v-else>
															<span class="read-font" v-if="textIndex == index">已送达</span
															><i
																class="no-read"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
													</div>
													<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
													<i
														class="el-icon-warning errorColor"
														@click="repeatSendFileAction(item)"
														v-if="item.contentList[0].sendType == 3"
													></i>
												</div>
												<div>
													<div v-if="imgFlag == index">
														<sky-img-preview
															:file="{
																url: item.contentList[0].urls,
																ossName: '8144864489269305344.png',
															}"
															file-name="AHHAH"
															:visible.sync="dialogVisible"
															title="查看图片"
															:img-url="item.contentList[0].urls"
															@on-cancel="showImg(index, -1)"
															:append="true"
														></sky-img-preview>
													</div>
													<img
														:src="item.contentList[0].urls"
														@click="showImg(index)"
														class="img-box-self"
													/>
													<div
														class="error-text"
														@click="repeatSendFileAction(item)"
														v-if="item.contentList[0].sendType == 3"
													>
														发送失败，点击重试
													</div>
												</div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
											<!-- 视频 -->
											<div
												class="video_box reaction-box"
												v-else-if="item.contentList[0].msgType == 'video'"
												@mouseenter="mouseenter(index)"
												@mouseleave="mouseleave"
											>
												<div class="error-tip">
													<div
														v-if="newOrold && userType != 1 && item.contentList[0].sendType == 2"
													>
														<div v-if="item.readFlag == 1">
															<span class="read-font" v-if="textIndex == index">已读</span
															><i
																class="el-icon-circle-check"
																style="color: #999999"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
														<div v-else>
															<span class="read-font" v-if="textIndex == index">已送达</span
															><i
																class="no-read"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
													</div>
													<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
													<i
														class="el-icon-warning errorColor"
														@click="repeatSendFileAction(item)"
														v-if="item.contentList[0].sendType == 3"
													></i>
												</div>
												<div>
													<video
														ref="videoPlayer"
														controls
														:src="item.contentList[0].urls"
														class="video_content"
													></video>
													<div
														class="error-text"
														@click="repeatSendFileAction(item)"
														v-if="item.contentList[0].sendType == 3"
													>
														发送失败，点击重试
													</div>
												</div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
											<!-- 文件 -->
											<div
												class="document_box reaction-box"
												v-else-if="item.contentList[0].msgType == 'document'"
												@mouseenter="mouseenter(index)"
												@mouseleave="mouseleave"
											>
												<div class="error-tip">
													<div
														v-if="newOrold && userType != 1 && item.contentList[0].sendType == 2"
													>
														<div v-if="item.readFlag == 1">
															<span class="read-font" v-if="textIndex == index">已读</span
															><i
																class="el-icon-circle-check"
																style="color: #999999"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
														<div v-else>
															<span class="read-font" v-if="textIndex == index">已送达</span
															><i
																class="no-read"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
													</div>
													<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
													<i
														class="el-icon-warning errorColor"
														@click="repeatSendFileAction(item)"
														v-if="item.contentList[0].sendType == 3"
													></i>
												</div>
												<div>
													<div
														class="file_style"
														@click="
															attachmentDownload(item.contentList[0])
														"
													>
														<el-row>
															<el-col :span="20" class="file_sub">
																<div>{{ item.contentList[0].fileName | fileNameFilter }}</div>
																<div class="fileSize">{{ item.contentList[0].fileSizeStr }}</div>
															</el-col>
															<el-col :span="4">
																<img
																	:src="item.contentList[0].fileName | numfilters"
																	class="fileName"
																/>
															</el-col>
														</el-row>
													</div>
													<div
														class="error-text"
														v-if="item.contentList[0].sendType == 3"
														@click="repeatSendFileAction(item)"
													>
														发送失败，点击重试
													</div>
												</div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
											<!-- 弹框 -->
											<!-- <div v-else-if="item.contentList[0].type == 5"
                           style="display: flex; float: right">
                        <div class="error-tip"
                             v-if="newOrold && userType != 1">
                          <div v-if="item.readFlag == 1">
                            <span class="read-font"
                                  v-if="textIndex == index">已读</span><i class="el-icon-circle-check"
                               style="color: #999999"
                               @mouseenter="textenter(index)"
                               @mouseleave="textleave"></i>
                          </div>
                          <div v-else>
                            <span class="read-font"
                                  v-if="textIndex == index">已送达</span><i class="no-read"
                               @mouseenter="textenter(index)"
                               @mouseleave="textleave"></i>
                          </div>
                        </div>
                        <div class="popup-box"
                             @mouseenter="mouseenter(index)"
                             @mouseleave="mouseleave">
                          <div class="underline">
                            {{ JSON.parse(item.contentList[0].content)[0].content }}
                          </div>
                          <div style="
													display: flex;
													flex-direction: column;
													justify-content: center;
													align-items: center;
												">
                            <div v-if="
														JSON.parse(item.contentList[0].content)[1] &&
														JSON.parse(item.contentList[0].content)[1].content
													"
                                 class="button">
                              {{ JSON.parse(item.contentList[0].content)[1].content }}
                            </div>
                            <div v-if="
														JSON.parse(item.contentList[0].content)[2] &&
														JSON.parse(item.contentList[0].content)[2].content
													"
                                 class="button">
                              {{ JSON.parse(item.contentList[0].content)[2].content }}
                            </div>
                            <div v-if="
														JSON.parse(item.contentList[0].content)[3] &&
														JSON.parse(item.contentList[0].content)[3].content
													"
                                 class="button">
                              {{ JSON.parse(item.contentList[0].content)[3].content }}
                            </div>
                          </div>
                        </div>
                      </div> -->
											<!-- 音频 -->
											<div
												v-else-if="item.contentList[0].msgType == 'audio'"
												class="document_box reaction-box"
											>
												<div class="error-tip">
													<div
														v-if="newOrold && userType != 1 && item.contentList[0].sendType == 2"
													>
														<div v-if="item.readFlag == 1">
															<span class="read-font" v-if="textIndex == index">已读</span
															><i
																class="el-icon-circle-check"
																style="color: #999999"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
														<div v-else>
															<span class="read-font" v-if="textIndex == index">已送达</span
															><i
																class="no-read"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
													</div>
													<i class="el-icon-loading" v-if="item.contentList[0].sendType == 1"></i>
													<i
														class="el-icon-warning errorColor"
														v-if="item.contentList[0].sendType == 3"
														@click="repeatSendFileAction(item)"
													></i>
												</div>
												<audio-play
													:url="item.contentList[0].urls"
													:position="'right'"
												></audio-play>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
											<!-- 模板 -->
											<div
												v-else-if="item.contentList[0].msgType == 'template'"
												class="template-content reaction-box"
											>
												<div class="error-tip">
													<div
														v-if="newOrold && userType != 1 && item.contentList[0].sendType == 2"
													>
														<div v-if="item.readFlag == 1" style="display: flex">
															<span class="read-font" v-if="textIndex == index">已读</span>
															<i
																class="el-icon-circle-check"
																style="color: #999999"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
														<div v-else style="display: flex">
															<span class="read-font" v-if="textIndex == index">已送达</span
															><i
																class="no-read"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
													</div>
													<i
														class="el-icon-warning errorColor"
														@click="repeatSendFileAction(item)"
														v-if="item.contentList[0].sendType == 3"
													></i>
												</div>
												<div class="content-self">
													<whatsappTemplateMsg v-model="item.contentList[0].templateContentVO">
													</whatsappTemplateMsg>
												</div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
											<!-- 文本 -->
											<div v-else class="text-content reaction-box">
												<div class="error-tip">
													<div
														v-if="newOrold && userType != 1 && item.contentList[0].sendType == 2"
													>
														<div v-if="item.readFlag == 1" style="display: flex; align-items: center;">
															<span class="read-font" v-if="textIndex == index">已读</span>
															<i
																class="el-icon-circle-check"
																style="color: #999999"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
														<div v-else style="display: flex">
															<span class="read-font" v-if="textIndex == index">已送达</span
															><i
																class="no-read"
																@mouseenter="textenter(index)"
																@mouseleave="textleave"
															></i>
														</div>
													</div>
													<i
														class="el-icon-warning errorColor"
														@click="repeatSendFileAction(item)"
														v-if="item.contentList[0].sendType == 3"
													></i>
												</div>

												<div
													class="content-self"
													v-html="item.contentList[0].content.replace(/\n/g, '<br />')"
													@mouseenter="mouseenter(index)"
													@mouseleave="mouseleave"
												></div>
												<div v-if="item.contentList[0].reactionVO" class="reaction-info">
													{{ item.contentList[0].reactionVO.emoji }}
												</div>
											</div>
                    </div>
                  </div>
              </div>
              <div class="img-container">
                <img :src="require('@/assets/chat/sysDefault.png')"
                     class="img"
                     v-if="item.sendoutType == 1" />
                <img :src="item.fbThumb || require('@/assets/default.png')"
                     class="img"
                     v-else />
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <!-- 云盘弹框 -->

    <skyImgRotate :imgUrl="imgUrl"
                  :title="'图片预览'"
                  :append='true'
                  :visible.sync="imgRotateVisible" />
                  <el-dialog title="联系人信息" :visible.sync="contactVisible" width="500px">
			<div class="contact-dialog" v-for="(item, index) in contactInfoList" :key="index">
				<div class="contact-info-left">
					<img :src="require('@/assets/default.png')" class="img" />
				</div>
				<div class="contact-info-right">
					<div class="contact-info-name">
						{{ item.name.formattedName }}
						<div class="contact-info-phone">
							<div v-for="i in item.phones" :key="i.id">{{ i.phone }}</div>
						</div>
					</div>
					<div v-if="item.org">公司：{{ item.org.company }}</div>
					<div v-if="item.addresses">
						地址：
						<span v-for="address in item.addresses" :key="address.id">
							{{ address.country }} {{ address.city }} {{ address.street }}
						</span>
					</div>
					<div style="display: flex" v-if="item.emails">
						邮箱：
						<div>
							<div v-for="email in item.emails" :key="email.id">{{ email.email }}</div>
						</div>
					</div>
					<div style="display: flex" v-if="item.urls">
						网址：
						<div>
							<div v-for="url in item.urls" :key="url.id">{{ url.url }}</div>
						</div>
					</div>
					<div v-if="item.birthday">生日：{{ item.birthday }}</div>
				</div>
			</div>
		</el-dialog>
  </div>
</template>
<script>
import audioPlay from '@/components/chat/components/audio-play.vue';
import skyImgPreview from '@/components/iglobalwin/formComponents/sky-img-preview.vue';
import skyImgRotate from '@/components/iglobalwin/formComponents/sky-img-rotate.vue';
import { download2, cloudDiskJudgmentType, downloadImg} from '@/common/util.js';
import { mapGetters } from 'vuex';
import { eventBuriedPoint } from '@/common/buriedPoint.js';
import messageReference from './message-reference.vue';
import whatsappTemplateMsg from './whatsapp-template-msg.vue';

export default {
  props: {
    list: {
      type: Array,
    },
    firstTime: {
      type: String,
    },
    // time: {
    // 	type: String,
    // },
    endFlag: null,
    isbrowse: {
      type: Boolean,
      default: true,
    },
    userType: null,
    sourceTypeStr: null,
    moreTextFlag: null,
    scollFlag: {
      type: Boolean,
      default: false,
    },
    headerInfo: {
      type: Object
    }
  },
  data () {
    return {
      imgFlag: -1,
      dd: 0,
      hh: '00',
      mm: '00',
      ss: '00',
      flag: false,
      showTime: false,
      checkIndex: -1,
      dialogVisible: false,
      moreText: '查看更多消息...',
      displayStart: 1,
      moreFlag: true,
      height: 0,
      textIndex: -1,
      imgRotateVisible: false,
      imgUrl: '',
      contactVisible: false,
			contactInfoList: [],
    };
  },
  filters: {
    fileNameFilter (value) {
      let len = value.length;
      if (!value) return '';
      if (value.length > 20) {
        return value.substring(0, 12) + '...' + value.substring(len - 12, len);
      }
      return value;
    },
    numfilters(val) {
			const typeList = {
				xls: {
					img: 'xls.png',
				},
				xlsx: {
					img: 'xls.png',
				},
				txt: {
					img: 'txt.png',
				},
				pdf: {
					img: 'pdf.png',
				},
				doc: {
					img: 'word.png',
				},
				docx: {
					img: 'word.png',
				},
				zip: {
					img: 'zip.png',
				},
				ppt: {
					img: 'ppt.png',
				},
				pptx: {
					img: 'ppt.png',
				},
				rar: {
					img: 'rar.png',
				},
				others: {
					img: 'o-file.png',
				},
				// mp4: {
				// 	img: 'file.png',
				// },
			};
			const type = val.substring(val.lastIndexOf('.') + 1).toLowerCase(); // 截取的图片类型
			return type && typeList[type]
				? require(`@/assets/${typeList[type].img}`)
				: require(`@/assets/${typeList['others'].img}`);
		},
  },
  watch: {
    list: {
      handler (val) {
        //每次改变的时候都会到底部，点击查看更多
        this.$nextTick(() => {
          if (!this.scollFlag) {
              this.$refs['myScrollbar'].wrap.scrollTop = this.$refs['myScrollbar'].wrap.scrollHeight;
          } else {
              this.$refs['myScrollbar'].wrap.scrollTop =
              this.$refs['myScrollbar'].wrap.scrollHeight - this.height;
          }
        });
      },
      deep: true,
      immediate: true,
    },
    endFlag: {
      deep: true,
      immediate: true,
      handler () {
        if (this.endFlag == 1) {
          this.hh = '00';
        }
        this.mm = '00';
        this.ss = '00';
        this.dd = '';
      },
    },
    'headerInfo.firstTime': {
      deep: true,
      immediate: true,
      handler (val) {
        this.flag = false;
        let time = setInterval(() => {
          if (this.flag) {
            clearInterval(time);
            this.hh = '00';
            this.mm = '00';
            this.ss = '00';
            this.dd = '';
          }
          if (this.endFlag != 1) {
            this.timeDown();
          }
        }, 500);
      },
    },
  },
  computed: {
    ...mapGetters(['cloudDiskFunctionNum']),
    userTypeStr () {
      return this.userType == 1 ? '第一条' : '最后一条';
    },

    newOrold () {
      return this.$route.name !== 'liveChat';
    },
    checkChinese () {
      let val = this.headerInfo.nickname ;
      var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
      if (reg.test(val)) {
        return val.substring(0, 1);
      } else {
        if (val) {
          val = val.toLowerCase();
          let name = val.charAt(0).toUpperCase() + val.slice(1);
          return name.substring(0, 2);
        }
      }
      return '无';
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs['myScrollbar'].wrap.scrollTop = this.$refs['myScrollbar'].wrap.scrollHeight;
    });
  },
  methods: {
    // 存云盘
    async savecloudDisk (data) {
      if (this.cloudDiskFunctionNum <= 0) {
        this.$alert('您暂未购买云盘功能，请联系您的专属商务购买体验', '提示', {
          confirmButtonText: '确定',
        });
      } else {
        let { fileName, fileSize: size, urls: url } = data
        let { cancel } = await this.$refs.skyCloudDisk.show({
          fileName,
          size,
          url
        });
        // 云盘埋点
        if (!cancel) eventBuriedPoint('/cloudDiskTransfer');
      }
    },
    // 文件下载
    attachmentDownload(data) {
      let { fileName, urls: url } = data
      if (data.msgType == "document") {
        download2(url, fileName)
      } else {
        url = url + "?t=" + new Date().getTime();
        fetch(url).then((response) => {
          response.blob().then((myBlob) => {
            const href = URL.createObjectURL(myBlob);
            let a = document.createElement("a");
            a.href = href;
            a.download = fileName;
            a.click();
          });
        });
      }
    },
    // 文件判断
    cloudDiskJudgmentType (data) {
      let { urls } = data
      return cloudDiskJudgmentType(urls);
    },
    // 文件预览 
    attachmentView (data) {
      let typelist = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'];
      let isImg = data
        ? typelist.indexOf(data.urls.slice(data.urls.lastIndexOf('.') + 1)) !== -1
        : false;
      if (isImg) {
        this.imgUrl = data.urls;
        this.imgRotateVisible = true;
        return;
      }
      if (data.urls.slice(data.urls.lastIndexOf('.') + 1) !== 'pdf') {
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${data.urls}`);
      } else {
        window.open(data.urls);
      }
    },
    textenter (index) {
      this.textIndex = index;
    },
    textleave () {
      this.textIndex = -1;
    },
    showImg (index, flag) {
      if (flag) {
        this.imgFlag = flag;
        this.dialogVisible = false;
      } else {
        this.imgFlag = index;
        this.dialogVisible = true;
      }
    },
    more () {
      this.height = this.$refs['myScrollbar'].wrap.scrollHeight;
      let recordId = this.list[0].recordId;
      let sendTime = this.list[0].sendTime;
      ++this.displayStart;
      this.$emit('more', this.displayStart, recordId, sendTime);
    },
    download (url, name) {
      const a = document.createElement('a');
      a.style.display = 'none';
      // 这里是将url转成blob地址，
      let urlstr;
      if (url.indexOf('https') == -1) {
        urlstr = url.slice(0, 4) + 's' + url.slice(4);
      } else {
        urlstr = url;
      }
      // window.open(urlstr);
      fetch(urlstr)
        .then(res => res.blob())
        .then(blob => {
          // 将链接地址字符内容转变成blob地址
          a.href = URL.createObjectURL(blob);
          a.download = name; // 下载文件的名字
          document.body.appendChild(a);
          a.click();
        });
    },
    timeDown () {
      let time;
      // if (this.userType == 1) {
      //   time = 24 * 60 * 60 * 1000;
      // } else {
      //   time = 7 * 24 * 60 * 60 * 1000;
      // }
      time = 24 * 60 * 60 * 1000 * 7;
      const endTime = Date.parse(new Date(this.headerInfo.firstTime)) + time;
      const nowTime = Date.parse(new Date(this.headerInfo.firstTime));
      var date = new Date();
      var now = date.getTime(nowTime);
      //设置截止时间
      var endDate = new Date(endTime);
      var end = endDate.getTime();
      //时间差
      var rightTime = end - now; //截止时间减去当前时间
      if (rightTime > 0) {
        //判断剩余倒计时时间如果大于0就执行倒计时否则就结束
        var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
        var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
        var mm = Math.floor((rightTime / 1000 / 60) % 60);
        var ss = Math.floor((rightTime / 1000) % 60);
        this.hh = hh;
        this.mm = mm;
        this.ss = ss;
        this.dd = dd;
      } else {
        this.flag = true;
      }
    },
    mouseenter (index) {
      this.checkIndex = index;
    },
    mouseleave () {
      this.checkIndex = -1;
    },
    resend () { },
    repeatSendFileAction (item) {
      this.$emit('repeatSendFileAction', item);
    },
    viewContact(list) {
			this.contactInfoList = list;
			this.contactVisible = true;
		},
  },
  components: {
    skyImgPreview,
    audioPlay,
    skyImgRotate,
    messageReference,
    whatsappTemplateMsg
  },
};
</script>
<style lang="scss" scoped>
.contactProfilePicture {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  text-align: center;
  line-height: 42px;
  font-size: 18px;
}
.xiansuo {
  background: rgba(61, 161, 255, 0.16);
  border: 1px solid #3da1ff;
  color: #2691e9;
}
.filePopperContent_body {
	width: 200px;
	display: flex;
	flex-direction: column;
	align-items: center;

	.filePopperContent_title {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		vertical-align: bottom;
		text-overflow: ellipsis;
		text-align: center;
	}

	.filePopperContent_content {
		width: 100%;
		display: flex;
		flex-direction: row;
		margin-top: 10px;
		justify-content: space-around;

		.operation {
			display: flex;
			flex-direction: column;
		}
	}
}
.chat {
	// height: 600px;

	height: calc(100vh - 250px);
	.content-box {
		// margin-top: 15px;
		height: calc(100vh - 300px);
	}
}
.timeTip_box {
	position: relative;
	text-align: center;
	display: flex;
	/* 水平居中 */
	justify-content: center;
	/* 垂直居中 */
	align-items: center;
}
.timeTip {
	max-width: 620px;
	// display: inline-block;
	height: 30px;
	background: #fff4c8;
	border-radius: 4px;
	font-weight: 400;
	color: #f89d29;
	font-size: 12px;
	text-align: center;
	line-height: 30px;
	padding: 0px 10px;
	margin-top: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.img-container {
	width: 40px;
}
.chat-box {
	width: 75%;
	margin-bottom: 30px;
	text-align: left;
	display: flex;
	.content {
		display: inline-block;
		word-break: break-all;
		margin-top: 10px;
		padding: 11px 15px;
		background: #f9f9f9;
		box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
		border-radius: 6px;
	}
	.chat-content {
		display: inline-block;
		margin-left: 10px;
	}
}
.chat-box-self {
	display: flex;
	width: 75%;
	float: right;
	// margin-left: 50%;
	justify-content: flex-end;
	padding-bottom: 30px;
	.text-content {
		// display: inline-block;
		display: flex;
		justify-content: end;
    align-items: center;
    margin-top: 10px;
	}
	.read-font {
		color: #999999;
    white-space: nowrap;
    margin-right: 10px;
	}
	.no-read {
		display: inline-block;
		border: 1px #3da1ff solid;
		border-radius: 50%;
		width: 13px;
		height: 13px;
		margin-top: 3px;
	}
	.content-self {
		// float: right;
		display: inline-block;
		word-break: break-all;
		// margin-top: 10px;
		padding: 11px 15px;
		background: #c6e5ff;
		color: #000;
		box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
		border-radius: 6px;
	}
	.chat-content-self {
		margin-right: 10px;
	}
}
.img {
	width: 40px;
	height: 40px;
	background: #d3d6db;
	border-radius: 20px;
	object-fit: contain;
	display: inline-block;
	vertical-align: top;
}
.video_box {
	display: flex;
	margin-top: 10px;
	.video_content {
		width: 250px;
		height: 180px;
		// object-fit: fill;
		border-radius: 10px;
	}
}
.file_style {
	cursor: pointer;
	width: 260px;
	max-height: 100px;
	// height: 80px;
	background: #ffffff;
	border-radius: 6px;
	border: 1px solid #e8e8e8;
	padding: 15px;
	.file_sub {
		word-wrap: break-word;
		display: block;
		.fileSize {
			margin-top: 10px;
		}
	}
	.fileName {
		width: 35px;
		height: 40px;
	}
}
.imgcontent-self {
	margin-top: 10px;
	display: flex;
	width: 260px;
	flex-direction: row;
	justify-content: flex-end;
	.img-box-self {
		cursor: pointer;
		max-width: 250px;
		max-height: 200px;
		// object-fit: contain;
		// float: right;
	}
}
.imgcontent {
	// display: flex;
	// display: inline-block;
	margin-top: 10px;
	.img-box {
		cursor: pointer;
		max-width: 250px;
		max-height: 200px;
		object-fit: contain;
	}
	.img-box-self {
		float: right;
	}
}
.moreText {
	font-size: 10px;
	text-align: center;
	color: #3da1ff;
	cursor: pointer;
	padding-top: 5px;
}
.greyMoreText {
	font-size: 10px;
	text-align: center;
	color: #666666;
	padding-top: 5px;
}
.error-tip {
	max-width: 150px;
	padding-right: 10px;
	display: flex;
	align-items: center;
	justify-content: right;
  >div {
    >div {
      display: flex;
      align-items: center;
    }
  }
}
.error-text {
	color: red;
	padding: 10px;
	font-size: 12px;
}
.errorColor {
	cursor: pointer;
	color: red;
}
.popup-box {
	max-width: 250px;
	margin-top: 10px;
	padding: 11px 15px;
	background: #c6e5ff;
	color: #000;
	box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
	border-radius: 6px;
	.underline {
		padding-bottom: 10px;
		border-bottom: 1px #ffffff solid;
	}
	.button {
		text-align: center;
		width: 150px;
		margin-top: 10px;
		padding: 5px 10px;
		// border: 1px #ffffff solid;
		background: #ffffff;
		border-radius: 6px;
	}
}
.contact-info {
	padding: 11px 15px;
}
.chat-map {
	height: 300px;
	width: 300px;
}
.contact-dialog {
	display: flex;
	margin-bottom: 20px;
	div {
		line-height: 30px;
	}
	.contact-info-right {
		margin-left: 20px;
	}
	.contact-info-name {
		display: flex;
	}
	.contact-info-phone {
		margin-left: 20px;
	}
}
.contact-reference {
	padding: 11px 15px;
}

.reaction-box {
	position: relative;
  display: flex;
}
.view-all {
	text-align: center;
	border-top: 1px solid rgba(185, 187, 189, 0.4);
	padding: 11px 15px;
	cursor: pointer;
}
.reaction-info {
	position: absolute;
	background: #fff;
	padding: 0px 8px;
	border-radius: 13px;
	right: 5px;
	bottom: -20px;
	box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.07);
	border: 1px solid #f8f8f8;
}
.reaction-info-recive {
	position: absolute;
	background: #fff;
	padding: 0px 8px;
	border-radius: 13px;
	left: 5px;
	bottom: -20px;
	box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.07);
	border: 1px solid #f8f8f8;
}
</style>
